import { loadScript } from "../../../utils/js/utils.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";

export function init() {
  exposeGlobal();
  loadGPT();
}

function loadGPT() {
  const dispatch = () => {
    events.fire(window, "gpt.loaded");
  };

  if (window.googletag?.apiReady) {
    dispatch();
  } else {
    loadScript("https://securepubads.g.doubleclick.net/tag/js/gpt.js").then(
      () => {
        window.googletag.cmd.push(dispatch);
      }
    );
  }
}

function exposeGlobal() {
  window.googletag = window.googletag || { cmd: [] };
}
